<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <el-breadcrumb-item>业务员账号列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <el-row :gutter="20" v-if="canLook == 1">
        <el-col :span="3">
          <el-button type="primary" @click="addDialogVisible = true">添加业务员</el-button>
        </el-col>

        <el-col :span="4" v-if="canLook == 1">
          <el-upload
            ref="upload"
            class="upload-demo"
            :action="uploadURL"
            :headers="headerObj"
            accept=".xlsx"
            :limit="1"
            :before-upload="beforeUpload"
            :on-change="handleChange"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-success="handleSuccess"
            :on-error="handleError"
            :file-list="fileList"
          >
            <el-button type="primary">批量上传</el-button>
          </el-upload>
        </el-col>
        <el-col :span="6"> </el-col>
      </el-row>

      <!-- 用户列表区域 -->
      <el-table :data="userlist" border stripe>
        <!-- <el-table-column fixed type="selection" width="55"> </el-table-column> -->
        <el-table-column type="index"></el-table-column>
        <el-table-column label="名称" prop="name" width="120px"></el-table-column>
        <el-table-column label="状态" width="90px">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" @change="userStateChanged(scope.row)"> </el-switch>
          </template>
        </el-table-column>

        <el-table-column label="操作" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)"></el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeUserById(scope.row.id)"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 添加用户的对话框 -->
    <el-dialog title="添加" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="130px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="addForm.phone"></el-input>
        </el-form-item>
      </el-form>

      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUser">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改用户的对话框 -->
    <el-dialog title="修改用户" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed">
      <el-form :model="editForm" :rules="addFormRules" ref="editFormRef" label-width="130px">
        <el-form-item label="登陆手机号">
          <el-input v-model="editForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editUserInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {

    return {
      canLook: 1,
      uploadURL: 'https://hsapi.hsxsn.cn//common/uploadFile',
      // 图片上传组件的headers请求头对象
      headerObj: {
        Authorization: window.sessionStorage.getItem('token')
      },
      limit: 1,  // 上传excell时，同时允许上传的最大数
      fileList: [],   // excel文件列表

      // 获取用户列表的参数对象
      queryInfo: {
        query: '',
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少条数据
        pagesize: 10
      },

      userlist: [],
      total: 0,

      // 控制添加用户对话框的显示与隐藏
      addDialogVisible: false,
      // 添加用户的表单数据
      addForm: {
        phone: '',
        name: '',
      },
      // 添加表单的验证规则对象
      addFormRules: {
        name: [
          { required: true, message: '请输入昵称', trigger: 'blur' },

        ], phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ]
      },

      // 控制修改用户对话框的显示与隐藏
      editDialogVisible: false,
      // 查询到的用户信息对象
      editForm: {
        id: '',
        phone: '',
        name: ''
      },
      // 修改表单的验证规则对象
      editFormRules: {
        name: [
          { required: true, message: '请输入昵称', trigger: 'blur' },

        ], phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ]
      },

      // 控制分配角色对话框的显示与隐藏
      setRoleDialogVisible: false,
      // 需要被分配角色的用户信息
      userInfo: {},
      // 所有角色的数据列表
      rolesList: [],
      // 已选中的角色Id值
      selectedRoleId: null,
      multipleSelection: [],
      multipleSelectionjson: null,
    }
  },

  created () {
    this.getUserList()
    // this.getUserRoleList()
  },

  methods: {
    async getUserList () {
      const { data: res } = await this.$http.get('admin/user/getAllSalemans')
      if (res.code !== 200) {
        return this.$message.error('用户列表！')
      }
      this.userlist = res.result
      if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
      // this.total = res.result.count
      console.log(res)
    },


    // 监听 pagesize 改变的事件
    handleSizeChange (newSize) {
      // console.log(newSize)
      this.queryInfo.pagesize = newSize
      this.getUserList()
    },

    // 监听 页码值 改变的事件
    handleCurrentChange (newPage) {
      console.log(newPage)
      this.queryInfo.pagenum = newPage
      this.getUserList()
    },

    // 监听 switch 开关状态的改变
    async userStateChanged (userinfo) {
      console.log(userinfo)
      const { data: res } = await this.$http.post('/admin/user/updateSalemanStatus', {
        status: userinfo.status,
        id: userinfo.id
      })
      if (res.code !== 200) {
        userinfo.status = !userinfo.status
        return this.$message.error('更新用户状态失败！')
      }
      this.$message.success('更新用户状态成功！')
    },

    // 监听添加用户对话框的关闭事件
    addDialogClosed () {
      this.$refs.addFormRef.resetFields()
    },

    // 点击按钮，添加新用户
    addUser () {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return
        // 可以发起添加用户的网络请求
        const { data: res } = await this.$http.post('admin/user/addSalemanUser', this.addForm)
        if (res.code !== 200) {
          this.$message.error(res.message)
          return;
        }
        this.$message.success(res.message)
        // 隐藏添加用户的对话框
        this.addDialogVisible = false
        // 重新获取用户列表数据
        this.getUserList()
      })
    },

    // 展示编辑用户的对话框
    async showEditDialog (id) {
      // console.log(phone)
      const { data: res } = await this.$http.get('admin/user/baseSalemanInfo', {
        params: { id: id }
      })
      if (res.code !== 200) {
        return this.$message.error('查询用户信息失败！')
      }
      this.editForm = res.result
      this.editDialogVisible = true
    },

    // 监听修改用户对话框的关闭事件
    editDialogClosed () {
      this.$refs.editFormRef.resetFields()
    },
    // 修改用户信息并提交
    editUserInfo () {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return
        // 发起修改用户信息的数据请求
        const { data: res } = await this.$http.post(
          'admin/user/editSalemanInfo',
          this.editForm
        )
        if (res.code !== 200) {
          return this.$message.error('更新用户信息失败！')
        }

        // 关闭对话框
        this.editDialogVisible = false
        // 刷新数据列表
        this.getUserList()
        // 提示修改成功
        this.$message.success('更新用户信息成功！')
      })
    },
    // 根据Id删除对应的用户信息
    async removeUserById (id) {
      // 弹框询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将永久删除该用户, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      const { data: res } = await this.$http.post('admin/user/deleteSalemanInfo', { id: id })
      if (res.code !== 200) {
        return this.$message.error('删除用户失败！')
      }
      this.$message.success('删除用户成功！')
      this.getUserList()
    },

    //上传文件
    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUpload (file) {
      let extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      let size = file.size / 1024 / 1024;
      if (extension !== 'xlsx') {
        this.$message.warning('只能上传后缀是.xlsx的文件')
      }
      if (size > 10) {
        this.$message.warning('文件大小不得超过10M')
      }
    },

    // 文件状态改变
    handleChange (file, fileList) {
      console.log(file, fileList);
      if (file) {
        this.fileList = fileList.slice(-3)
      }
    },

    // 删除文件
    handleRemove (file, fileList) {
      this.fileList = []
    },

    // 文件超出个数限制
    handleExceed (files, fileList) {
      this.$message.warning(`只能选择 ${this.limitNum} 个文件，当前共选择了 ${files.length + fileList.length} 个`)
    },

    // 文件上传成功
    handleSuccess (res, file, fileList) {
      console.log(res, file, fileList);
      this.$message.success('上传成功')
    },

    // 文件上传失败
    handleError (err, file, fileList) {
      console.log(err, file, fileList);
      this.$message.error('上传失败')
    },

    // 覆盖默认的上传行为，自定义上传的实现
    uploadFile () {
      console.log(this.fileList);
      if (this.fileList.length === 0) {
        this.$message.warning('请上传文件')
      } else {

        const data = new FormData()
        const fileUps = file.file
        data.append('file', fileUps)
        this.$axios({
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          url: '/common/uploadFile',
          data: data,
          method: 'post'
        }).then(res => {
          console.log(res)

        }, err => {
          console.log(err)
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.aaaa {
  margin-left: 10px;
}
</style>
